import { Grid } from '@mui/material'
import './AmmunitionBox.scss'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import { MAmmunition } from '@Models/client/ammunition.model'

interface IAmmunitionBox {
    addAction?: (obj?: any) => void
    ammunition: MAmmunition
}

function AmmunitionBox(props: IAmmunitionBox) {
    const { addAction, ammunition } = props
    return (
        <div className="amunition-box">
            <div className="ammunition-container">
                <div className="title">{ammunition?.name}</div>
                <div className="detail">
                    <Grid container spacing={3}>
                        <Grid item lg={6} md={12} sm={12} xs={12}>
                            <div className="content">
                                <span className="label">Date</span>
                                <span className="value">
                                    {ammunition?.madeAt}
                                </span>
                            </div>
                            <div className="content">
                                <span className="label">Caliber</span>
                                <span className="value">
                                    {ammunition?.caliber}
                                </span>
                            </div>
                            <div className="content border-0">
                                <span className="label">FFL #</span>
                                <span className="value">
                                    {ammunition?.fflId}
                                </span>
                            </div>
                        </Grid>
                        <Grid item lg={6} md={12} sm={12} xs={12}>
                            <div className="content">
                                <span className="label">QTY</span>
                                <span className="value">{ammunition?.qty}</span>
                            </div>
                            <div className="content">
                                <span className="label">MS #</span>
                                <span className="value">
                                    {ammunition?.qmicrostamp}
                                </span>
                            </div>
                        </Grid>
                    </Grid>
                    <div className="btn-add">
                        <AddCircleOutlineIcon
                            className="add-icon"
                            onClick={(event: any) => {
                                if (addAction) addAction({ event, ammunition })
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AmmunitionBox
